import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import ChatItem from './ChatItem';
import ConciergeController, { ConciergeChatType } from '../../../controller/ConciergeController';
import { useOutletContext } from 'react-router-dom';
import { CurrentStoreContext } from '../../../controller/StoreController';
import { useRecoilValue } from 'recoil';
import {
  fcmConciergeCountState,
  fcmConciergeState,
  FcmConciergeType,
} from '../../../recoil/fcmMessage';
import HotelController, { RoomListType, AreaType } from '../../../controller/HotelController';
import { setRecoil } from 'recoil-nexus';
import DeviceList from '../../../components/DeviceList';
import { AuthContext } from '../../../navigation/AuthProvider';
import { useToast } from '../../../controller/ToastController';

const RequestChatList = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const oAuthContext = useContext(AuthContext);
  const user_id = oAuthContext.userInfo.user_id;
  const [deviceList, setDeviceList] = useState<AreaType[]>();
  const [areaList, setAreaList] = useState<any[]>([]);
  const [sendMessage, setSendMessage] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');

  //0: NEW , 1:답변완료
  const [status, setStatus] = useState<number>(0);

  const [chatList, setChatList] = useState<ConciergeChatType[]>([]);

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const messageFlag = useRecoilValue<FcmConciergeType>(fcmConciergeState);

  const handleResize = () => {
    if (window.innerWidth > 900) setIsMobile(false);
    else setIsMobile(true);
  };
  const onChangeMessage = (e: any) => {
    setMessage(e.target.value);
  };

  const getConciergeRequestList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
        status: status === 0 ? 'PROCESSING' : 'FINISHED',
      };
      const oResponse = await ConciergeController.getConciergeRequestList(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setChatList([...oRes.data.concierges]);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  const getDeviceList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
        user_id: user_id,
      };
      const oRes: any = await HotelController.getDevice(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        setDeviceList(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const writeMessage = async () => {
    if (areaList.length === 0) {
      showToast('객실을 선택해주세요.', 'error');
    } else if (message === '') {
      showToast('객실에 보낼 채팅을 입력해주세요.', 'error');
    } else {
      try {
        const oParams = {
          store_id: currentStore.value,
          area_id: areaList[0],
          accessor: 'HOTEL',
          message: message,
        };
        const oRes: any = await ConciergeController.writeMessage(oParams);

        if (oRes && oRes.data.ok) {
          setSendMessage(false);
          setMessage('');
          getConciergeRequestList();
        } else {
          showToast(oRes.data.msg, 'error');
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    getConciergeRequestList();
  }, [status]);

  useEffect(() => {
    getConciergeRequestList();
    setRecoil(fcmConciergeCountState, 0);
  }, [messageFlag]);
  useEffect(() => {
    getDeviceList();
    setSendMessage(false);
    setMessage('');
  }, []);
  console.log('룸선택:areaList>>>', areaList);
  return (
    <>
      <Style>
        <div className={'contentContainer'}>
          <div className="statusWrap">
            <div
              className={`statusItem ${status === 0 && 'active left'}`}
              onClick={() => {
                setStatus(0);
                setSendMessage(false);
              }}>
              <h3>NEW</h3>
            </div>
            <div
              className={`statusItem ${status === 1 && 'active right'}`}
              onClick={() => {
                setStatus(1);
                setSendMessage(false);
              }}>
              <h3>답변완료</h3>
            </div>
          </div>
          {!sendMessage ? (
            <div className="sendChatWrap">
              <button onClick={() => setSendMessage(true)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
                <p>객실지정 메세지 보내기</p>
              </button>
              <RenderOrderList
                chatList={chatList}
                isMobile={isMobile}
                status={status}
                getConciergeRequestList={getConciergeRequestList}
              />
            </div>
          ) : (
            <div className="chatdeviceWrap">
              <div className="deviceWrap">
                <img
                  onClick={() => setSendMessage(false)}
                  src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`}
                  alt="뒤로가기 버튼"
                />
                <DeviceList
                  deviceList={deviceList}
                  setAreaList={setAreaList}
                  disableCondition={false}
                  selectType="onlyOne"
                />
              </div>
              <div className="bar"></div>
              <div className="chatWrap">
                <textarea
                  value={message}
                  placeholder="객실에 보낼 채팅을 입력해주세요"
                  onChange={onChangeMessage}
                />
                <button onClick={writeMessage}>채팅 보내기</button>
              </div>
            </div>
          )}
        </div>
      </Style>
    </>
  );
};

const RenderOrderList = (oProps: {
  chatList: ConciergeChatType[];
  isMobile: boolean;
  status: number;
  getConciergeRequestList: any;
}) => {
  return oProps.chatList.length === 0 ? (
    <div className="noDataListWrap">
      <div className="titleIcon">
        <img src={`${process.env.PUBLIC_URL}/svg/ic_not_order.svg`} alt="img" />
      </div>
      <div className="title">
        <h3>요청사항이 없습니다</h3>
      </div>
    </div>
  ) : (
    <div className="chatListWrap">
      {oProps.chatList.map((chat, index) => {
        return (
          <ChatItem
            key={index}
            chat={chat}
            isMobile={oProps.isMobile}
            status={oProps.status}
            getConciergeRequestList={oProps.getConciergeRequestList}
          />
        );
      })}
    </div>
  );
};

export default RequestChatList;

const Style = styled.div`
  flex: 1;
  /* contentContainer */
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 !important;
    border-radius: 10px;
  }

  /* statusWrap */
  .statusWrap {
    border-radius: 10px 10px 0 0;
    display: flex;
    background: #ececec;

    .statusItem {
      flex: 1;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      justify-content: center;
      cursor: pointer;
      border-radius: 10px 10px 0 0;
      background: #e5e5e5;

      h3 {
        font-size: 18px;
        line-height: 24px;
        color: #a7a7a7;
        font-weight: 500;
      }

      .newButton {
        border-radius: 50px;
        padding: 2px 12px;
        background: #ff3542;
        margin-top: -44px;

        h5 {
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
        }
      }
    }
    .statusItem.active {
      background: #ffffff;

      h3 {
        color: #333333;
      }
    }
    .left {
      border-radius: 10px 0 0 0;
    }
    .right {
      border-radius: 0 10px 0 0;
    }
  }

  /* sendChatWrap */
  .sendChatWrap {
    width: 100%;
    padding: 38px 3vw;
    flex: 1;

    button {
      width: 100%;
      display: flex;
      padding: 10px;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border: 1px solid #4dd2ae;
      text-align: center;
      border-radius: 5px;
      color: #4dd2ae;

      p {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  /* orderWrap */
  .orderWrap {
    background: #fff;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    .orderTitle {
      /* position: sticky;
      margin-top: 1%;
      margin-bottom: auto;
      z-index: 3; */
      top: 0;
      position: sticky;
      width: 100%;
      display: flex;
      background: #ffffff;
      align-items: center;
      justify-content: flex-start;
      padding: 8px 0 8px 3vw;
      gap: 6px;
      z-index: 10;

      .dateButton {
        padding: 8px 36px;
        background: #fff;
        border-radius: 5px;
        color: #333333;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        border: 1px solid #999999;
      }
      .dateButton.active {
        background: #333;
        color: #ffffff;
        border: 1px solid #000000;
      }
    }
  }
  .orderList {
    margin: 10px 0;
  }

  .noDataListWrap {
    display: flex;
    flex-direction: column;
    height: 70%;
    justify-content: center;
    align-items: center;
    align-self: center;

    .title {
      h3 {
        font-size: 20px;
        line-height: 24px;
        color: #999999;
        font-weight: 500;
      }
    }
    .titleIcon {
      clear: both;
    }
  }

  /* chatListWrap */
  .chatListWrap {
    height: calc(100% - 64px);
    overflow-y: auto;
  }

  @media (max-width: 900px) {
    .statusWrap {
      margin: 0 10px;
      border-radius: 50px;
      background: #f7f7f7;
      border: 1px solid #e5e5e5;

      .statusItem {
        padding: 18px;
        border-radius: 50px;
        background: #f7f7f7;
        h3 {
          font-size: 22px;
          font-weight: 600;
        }
      }
      .statusItem.active {
        padding: 13px;
        border: 5px solid #f7f7f7;
        background: #4dd2ae;
        h3 {
          color: #ffffff;
        }
      }
    }
    .chatListWrap {
      max-height: 100vh;
    }
  }
  /* deviceListWrap */
  .chatdeviceWrap {
    .bar {
      width: 100%;
      height: 6px;
      background: #f7f7f7;
    }
  }
  .deviceWrap {
    height: 450px;
    padding: 0px 3vw;
    margin: 30px 0;
    overflow-y: scroll;
  }
  .chatWrap {
    padding: 30px 3vw;

    textarea {
      width: 100%;
      height: 120px;
      border: 1px solid #cecece;
      padding: 20px 30px;
      font-size: 18px;
      font-weight: 400;
      border-radius: 10px;
    }
    textarea::placeholder {
      color: #979797;
    }
    button {
      width: 100%;
      padding: 12px;
      margin-top: 30px;
      background: #4dd2ae;
      border-radius: 10px;
      color: #fff;
    }
  }
`;
